export default{
  // 当被绑定的元素插入到 DOM 中时……
  inserte(el, {value}) {
      el.scrollTop = value+'px';
  },
  update(el, {value}) {
    el.scrollTop = value+'px';
  }
}



// WEBPACK FOOTER //
// ./src/directive/v-scroll.js